// @flow
import _ from 'lodash';
import type {
  FilterSettingsState,
  FilterSettingsAction
} from 'stores/flow-type/filter-settings.type';

import {
  GET_FILTER_SETTINGS_REQUEST,
  GET_FILTER_SETTINGS_SUCCESS,
  GET_FILTER_SETTINGS_FAILURE,
  UPDATE_FILTER_SETTINGS_REQUEST,
  UPDATE_FILTER_SETTINGS_SUCCESS,
  UPDATE_FILTER_SETTINGS_FAILURE,
  CLEAR_CACHE_FILTER_SETTINGS_REQUEST,
  CLEAR_CACHE_FILTER_SETTINGS_SUCCESS,
  CLEAR_CACHE_FILTER_SETTINGS_FAILURE
} from 'stores/flow-type/filter-settings.type';

const initialState: FilterSettingsState = {
  loadingFilterSettings: false,
  savingFilterSettings: false,
  loadingClearCache: false,
  success: false,
  successSave: false,
  successClearCache: false,
  error: undefined,
  filterSettings: {},
  adminAppDisplay: {}
};

const filterSettingsReducers = (
  state: FilterSettingsState = initialState,
  action: FilterSettingsAction
) => {
  switch (action.type) {
    case GET_FILTER_SETTINGS_REQUEST:
      return { ...state, loadingFilterSettings: true };
    case UPDATE_FILTER_SETTINGS_REQUEST:
      return { ...state, savingFilterSettings: true, successSave: false };
    case CLEAR_CACHE_FILTER_SETTINGS_REQUEST:
      return { ...state, loadingClearCache: true, successClearCache: false };
    case GET_FILTER_SETTINGS_SUCCESS: {
      const { data, adminAppDisplay } = action.payload;
      const resultEmpty = _.get(data, 'label.resultEmpty');
      _.set(data, 'searchEmptyResultMessages.label', resultEmpty);
      return {
        ...state,
        loadingFilterSettings: false,
        success: true,
        error: undefined,
        filterSettings: { ...data },
        adminAppDisplay: { ...adminAppDisplay }
      };
    }
    case UPDATE_FILTER_SETTINGS_SUCCESS: {
      const { data, suggestionsList = {}, adminAppDisplay } = action.payload;
      let filterSettings = { ...data };
      const {
        productSuggestionsList = [],
        searchBoxProductSuggestionsList = [],
        productBackup = [],
        searchBoxProductSuggestionsBackup = []
      } = suggestionsList;

      if (!_.isEmpty(searchBoxProductSuggestionsList)) {
        _.set(
          filterSettings,
          `search.searchBoxOnclick.productSuggestion.data`,
          searchBoxProductSuggestionsList
        );
      }

      if (!_.isEmpty(searchBoxProductSuggestionsBackup)) {
        _.set(
          filterSettings,
          'search.searchBoxOnclick.productSuggestion.backup',
          searchBoxProductSuggestionsBackup
        );
      }

      if (!_.isEmpty(productSuggestionsList)) {
        _.set(filterSettings, `search.suggestionNoResult.products.data`, productSuggestionsList);
        _.set(
          filterSettings,
          `search.searchPanelBlocks.mostPopularProducts.productList`,
          productSuggestionsList
        );
      }

      if (!_.isEmpty(productBackup)) {
        _.set(filterSettings, `search.suggestionNoResult.products.backup`, productBackup);
        _.set(filterSettings, `search.searchPanelBlocks.mostPopularProducts.backup`, productBackup);
      }

      return {
        ...state,
        savingFilterSettings: false,
        success: true,
        successSave: true,
        error: undefined,
        filterSettings,
        adminAppDisplay: { ...adminAppDisplay }
      };
    }
    case CLEAR_CACHE_FILTER_SETTINGS_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...state,
        loadingClearCache: false,
        success: true,
        successClearCache: true,
        error: undefined,
        filterSettings: { ...data }
      };
    }
    case GET_FILTER_SETTINGS_FAILURE:
      return {
        ...state,
        loadingFilterSettings: false,
        success: false,
        error: action.payload
      };
    case UPDATE_FILTER_SETTINGS_FAILURE:
      return {
        ...state,
        savingFilterSettings: false,
        success: false,
        successSave: false,
        error: action.payload
      };
    case CLEAR_CACHE_FILTER_SETTINGS_FAILURE:
      return {
        ...state,
        loadingClearCache: false,
        success: false,
        successClearCache: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default filterSettingsReducers;
